import { unFollow } from 'apis/follow.api';
import { useContext } from 'react';
import {
  ISocketAcceptFollow,
  ISocketCancelRequestFollow,
  ISocketRequestFollow,
  TSocketOnError,
} from '../interfaces/common.interface';
import { SocketContext } from '../socket/socket-context';
import { useModal } from '../state/modal-provider/ModalProvider';

const useFollow = () => {
  const { socket, errorHandler } = useContext(SocketContext);
  const { toast } = useModal();

  const bindError = (onError?: TSocketOnError) => {
    errorHandler.onError = onError || (() => {});
  };

  const requestFollow = ({
    userId,
    callback,
    onError,
  }: ISocketRequestFollow) => {
    if (!socket) {
      return;
    }
    if (socket.connected) {
      bindError(onError);
      socket.emit('follow', { userId });
      callback && callback();
    } else {
      toast.error({
        content:
          'Có lỗi xảy ra khi kết nối với máy chủ, vui lòng kiểm tra lại mạng và thử tải lại trang',
        infinite: true,
      });
    }
  };

  const acceptFollow = ({ req, callback, onError }: ISocketAcceptFollow) => {
    if (!socket) {
      return;
    }

    if (socket.connected) {
      bindError(onError);
      socket.emit('accept-follow', req);
      callback && callback();
    } else {
      toast.error({
        content:
          'Có lỗi xảy ra khi kết nối với máy chủ, vui lòng kiểm tra lại mạng và thử tải lại trang',
        infinite: true,
      });
    }
  };

  const cancelRequestFollow = ({
    userId,
    callback,
    onError,
  }: ISocketCancelRequestFollow) => {
    if (!socket) {
      return;
    }

    if (socket.connected) {
      bindError(onError);
      socket.emit('cancel-follow', {
        cancelUserId: userId,
      });
      callback && callback();
    } else {
      toast.error({
        content:
          'Có lỗi xảy ra khi kết nối với máy chủ, vui lòng kiểm tra lại mạng và thử tải lại trang',
        infinite: true,
      });
    }
  };

  return {
    requestFollow,
    acceptFollow,
    cancelRequestFollow,
    unFollow: unFollow,
  };
};

export default useFollow;
